const EXPIRED_SESSION_PATTERN = /session could not be restored|room could not be found/i;

export function clockSyncSample(clientSentAt, serverNow, clientReceivedAt = Date.now()) {
  const sent = Number(clientSentAt);
  const server = Number(serverNow);
  const received = Number(clientReceivedAt);
  if (![sent, server, received].every(Number.isFinite) || received < sent) return null;
  const roundTripMs = received - sent;
  return {
    roundTripMs,
    serverOffsetMs: server - (sent + roundTripMs / 2),
  };
}

export function promptWithServerClockOffset(source, serverClockOffsetMs = 0) {
  const startsAtValue = source?.sequence?.startsAt;
  if (startsAtValue == null || startsAtValue === '') return source;
  const startsAt = Number(startsAtValue);
  if (!Number.isFinite(startsAt)) return source;
  const offset = Number(serverClockOffsetMs);
  return {
    ...source,
    sequence: {
      ...source.sequence,
      startsAt,
      serverClockOffsetMs: Number.isFinite(offset) ? offset : 0,
    },
  };
}

export function expiredSessionNotice(message, identity) {
  if (!identity || !EXPIRED_SESSION_PATTERN.test(String(message || ''))) return '';

  return identity.role === 'host'
    ? 'Your previous temporary room has ended. Your saved projects are safe, and you can create a new room.'
    : 'Your previous room has ended. You’re ready to enter the director’s new room code.';
}

export function connectionStatus({ connection, identity, canHost, canProvideSpeech = canHost } = {}) {
  if (!identity) return {
    state: 'ready',
    label: canProvideSpeech ? 'Director app ready' : 'Secure website ready',
  };
  if (connection === 'connected') return {
    state: 'connected',
    label: identity.role === 'host' ? 'Actor link ready' : 'Connected to director',
  };
  if (connection === 'connecting') return { state: 'connecting', label: 'Checking saved room' };
  return { state: 'offline', label: 'Reconnecting to room' };
}
